export default "__VITE_ASSET__0a6e00aa__"